import React from "react";
import { Content, Container } from "../../pages/Template";
import CreatePageLink from "./CreatePageLink";
import List from "./List";
import { isMobile, setWindowTitle } from "../../helpers";

type Props = {
    match: {
        params: {
            doc_id: string;
        };
    };
};
export class PagesPage extends React.Component<Props> {
    static paths = ["/app/pages/:doc_id"];
    static requiresAuth = true;

    componentDidMount() {
        setWindowTitle("صفحہ");
    }

    render() {
        const doc_id = parseInt(this.props.match.params.doc_id);
        return (
            <Content isLandingPage={isMobile()}>
                <Container>
                    <CreatePageLink doc_id={doc_id} />
                    <List doc_id={doc_id} />
                </Container>
            </Content>
        );
    }
}
